const VISUALS = [
  <>
    <path
      d="M30 50 C 120 50, 150 100, 190 100 M30 100 H190 M30 150 C 120 150, 150 100, 190 100"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth={1}
    />
    <path
      d="M190 100 C 230 100, 250 60, 280 52"
      fill="none"
      stroke="var(--color-accent)"
      strokeWidth={2}
    />
    <circle cx={280} cy={52} r={4} fill="var(--color-accent)" />
  </>,
  <>
    <path
      d="M60 150 V70 L150 30 L240 70 V150 M60 150 H240 M150 30 V110 M60 70 L150 110 L240 70"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth={1}
    />
    <path d="M150 110 V150" stroke="var(--color-accent)" strokeWidth={2} />
  </>,
  <>
    {[70, 46, 22].map((r) => (
      <circle
        key={r}
        cx={150}
        cy={100}
        r={r}
        fill="none"
        stroke="var(--color-ink)"
        strokeWidth={1}
      />
    ))}
    <path d="M150 100 L 200 50" stroke="var(--color-accent)" strokeWidth={2} />
    <circle cx={200} cy={50} r={4} fill="var(--color-accent)" />
  </>,
  <>
    <path
      d="M30 140 C 100 40, 200 40, 270 140"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth={1}
    />
    <path
      d="M30 60 C 100 160, 200 160, 270 60"
      fill="none"
      stroke="var(--color-accent)"
      strokeWidth={2}
    />
    <circle cx={30} cy={140} r={4} fill="var(--color-ink)" />
    <circle cx={270} cy={140} r={4} fill="var(--color-ink)" />
    <circle cx={30} cy={60} r={4} fill="var(--color-accent)" />
    <circle cx={270} cy={60} r={4} fill="var(--color-accent)" />
  </>,
  <>
    <g fill="var(--color-line)">
      {[50, 100, 150].map((y) =>
        [60, 105, 150, 195, 240].map((x) =>
          y === 100 && x === 150 ? null : <circle key={`${x}-${y}`} cx={x} cy={y} r={3} />,
        ),
      )}
    </g>
    <path
      d="M60 150 L105 100 L150 100 L195 50 L240 50"
      fill="none"
      stroke="var(--color-accent)"
      strokeWidth={2}
    />
    <circle cx={240} cy={50} r={4} fill="var(--color-accent)" />
  </>,
];

export function DirectionVisual({ index }: { index: number }) {
  return (
    <svg viewBox="0 0 300 200" className="h-full w-full" aria-hidden>
      {VISUALS[index % VISUALS.length]}
    </svg>
  );
}
